import React from 'react';
export const rootScrollViewRef = React.createRef();
//# sourceMappingURL=rootScrollViewRef.js.map